
import React from 'react';
import './customBanner.css';
import Carousel from 'react-bootstrap/Carousel';
import 'bootstrap/dist/css/bootstrap.min.css';

function CustomBanner({sideText, sideText2, slideUrl}) {

    return (
        <section id="cta-697">
            <Carousel>
                <Carousel.Item>
                    <a href="/krishna-temple-events">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/krishna-janmastami.jpg" 
                            alt="Janmasthami" >
                        </img>
                    </a>
                </Carousel.Item>
                <Carousel.Item>
                    <a href="/events/">
                        <img 
                            className="d-block mx-auto carousel-img"
                            src="/images/Radhastami.png" 
                            alt="Radhastami 2025" >
                        </img>
                    </a>
                </Carousel.Item>
            </Carousel>
        </section>
    )
}
export default CustomBanner